import { Button } from '@mui/material';
import { type FC } from 'react';
import styles from './ShowAllButton.module.scss';

interface Props {
  isShowAllVisible: boolean;
  isCollapseVisible: boolean;
  toggleExpanded: () => void;
}

const ShowAllButton: FC<Props> = ({ isShowAllVisible, isCollapseVisible, toggleExpanded }) => (
  <div className={styles.button}>
    {isCollapseVisible && (
      <Button sx={{ textTransform: 'none', textDecoration: 'underline' }} onClick={toggleExpanded}>
        {isShowAllVisible ? 'Show all' : 'Collapse'}
      </Button>
    )}
  </div>
);

export default ShowAllButton;
